// Design System Tokens - Central Export
// This file provides a single source of truth for all design tokens

export * from './colors';
export * from './spacing';
export * from './typography';
export * from './surfaces';

// Re-export all tokens in a single object for convenience
import { DESIGN_TOKENS as COLOR_TOKENS, LEGACY_COLORS } from './colors';
import { 
  SPACING_TOKENS, 
  BORDER_RADIUS_TOKENS, 
  SHADOW_TOKENS, 
  Z_INDEX_TOKENS,
  LEGACY_SPACING,
  LEGACY_BORDER_RADIUS 
} from './spacing';
import { TYPOGRAPHY_TOKENS } from './typography';

export const DESIGN_SYSTEM_TOKENS = {
  ...COLOR_TOKENS,
  ...SPACING_TOKENS,
  ...BORDER_RADIUS_TOKENS,
  ...SHADOW_TOKENS,
  ...Z_INDEX_TOKENS,
  ...TYPOGRAPHY_TOKENS,
} as const;

// Legacy exports for backward compatibility
export const LEGACY_TOKENS = {
  colors: LEGACY_COLORS,
  spacing: LEGACY_SPACING,
  borderRadius: LEGACY_BORDER_RADIUS,
} as const;

// Breakpoints (moved from constants)
export const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
  large: 1200,
} as const;

// Animation tokens
export const ANIMATION_TOKENS = {
  duration: {
    fast: '150ms',
    normal: '300ms',
    slow: '500ms',
  },
  easing: {
    linear: 'linear',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  // Legacy animation values
  legacy: {
    fadeIn: 800,
    slideUp: 1000,
    zoomIn: 1200,
    staggerDelay: 200,
    suggestionRotation: 3000,
    userCountUpdate: 30000,
    urgencyUpdate: 45000,
  },
} as const;